import React from "react";

export default function Web_jQuery() {
  return (
    <div>
      <h1>What is jQuery</h1>
      <p>
        Route: <code>/web/jquery</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
